import { MenuItem } from 'src/app/pages/user-center/left-menu.config';

export const memberMenu: any = [
  {
    title: 'fortune_center',
    center: false,
    page: 'bank',
    icon: 'fc',
  },
  {
    title: 'transaction_records',
    center: false,
    page: 'history',
    icon: 'tr',
  },
  {
    title: '安全指數',
    center: true,
  },
  {
    title: 'account_management',
    center: false,
    page: 'account',
    icon: 'am',
  },
  {
    title: 'member_center',
    center: false,
    page: 'center',
    icon: 'crown',
  },
];

export const memberMenu2: MenuItem[] = [
  {
    title: 'setting',
    icon: 'control',
    page: 'setting',
  },
];

export const MemberSetting: MenuItem[] = [
  {
    title: 'setting',
    icon: 'control',
    page: '',
  },
];

export const FortuneCenter: MenuItem[] = [
  {
    title: 'wallet_over', // 钱包总览
    icon: 'all-wallet',
    page: 'overview', //TODO
  },
  // {
  //   title: 'deposit', // 充值
  //   icon: 'deposit',
  //   page: 'deposit',
  //   type: 'fiat',
  // },
  // {
  //   title: 'withdraw', // 提现
  //   icon: 'withdraw',
  //   page: 'withdraw',
  //   type: 'fiat',
  // },
  // {
  //   title: "trans",// 划转
  //   icon: 'transfer',
  //   page: 'transfer'
  // },
  // {
  //   title: 'bc_manage', // 银行卡管理
  //   icon: 'bankcard2',
  //   page: 'bankcard',
  // },
  // {
  //   title: 'address_management', // 地址管理
  //   icon: 'crypto',
  //   page: 'address',
  // },
  {
    title: 'trans_history', // 钱包历史记录
    icon: 'history2',
    page: 'wallet-history',
  },
  {
    title: 'dep_not_arrive_title', // 充值未到账
    icon: 'appeal',
    page: 'retrieve-account',
    type: 'digital-record',
  },
];

export const TransactionRecords: MenuItem[] = [
  {
    title: 'sports', // 体育
    icon: 'sports',
    page: 'sport',
  },
  {
    title: 'lottery', // 彩票
    icon: 'lottery',
    page: 'lottery',
  },
  {
    title: 'casino', // 娱乐城
    icon: 'casino',
    page: 'casino',
  },
  {
    title: 'chess', // 棋牌
    icon: 'chess',
    page: 'poker',
  },
];

export const AccountManagement: MenuItem[] = [
  {
    title: 'dashboard', // 总览
    icon: 'users2',
    page: 'overview',
  },
  {
    title: 'account_security', // 帐户安全
    icon: 'shield2',
    page: 'global-settings/account',
    type: 'newSettings',
  },
  {
    title: 'settings', // 偏好设置
    icon: 'gear',
    page: 'global-settings/privacy',
    type: 'newSettings',
  },
  // {
  //   title: "gam_moderate",// 有节制博彩
  //   icon: 'note2',
  //   page: 'responsible-gambling'
  // },
  {
    title: 'message_notification', // 消息提醒
    icon: 'bell',
    page: 'notification-center',
  },
  {
    title: 'comments_and_feedback', // 意见和反馈
    icon: 'service2',
    page: 'feedback',
  },
  {
    title: 'referral_friend', // 推荐好友
    icon: '',
    page: '',
  },
];

export const MemberCenter: MenuItem[] = [
  {
    title: 'vip_bene00', // VIP 福利
    icon: 'mc',
    page: 'vip-level',
  },
  {
    title: 'vip_benefits', // VIP 权益
    icon: 'vip',
    page: 'vip-introduction',
  },
  {
    title: 'card_center', // 卡券中心
    icon: 'coupon2',
    page: 'coupon',
  },
  // {
  //   title: 'share_plan', // 分享计划
  //   icon: 'share3',
  //   page: 'share',
  // },
];
